import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "_flex _jc-c _ai-c _grow-1" }
const _hoisted_2 = { class: "_grid _gap-3 _pa-2 _ji-c" }
const _hoisted_3 = { class: "_tac" }
const _hoisted_4 = { class: "gfu-hd--h2" }
const _hoisted_5 = { class: "_flexcol _gap-2 _jcc" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_button = _resolveComponent("base-button")
  const _component_modal_box = _resolveComponent("modal-box")

  return ($options.isModalVisible)
    ? (_openBlock(), _createBlock(_component_modal_box, {
        key: 0,
        "is-visible": "",
        "has-backdrop": "",
        "show-action-close": "",
        width: "fullscreen",
        "is-processing": _ctx.isProcessing,
        onOpen: $options.onModalOpen,
        onActionClose: $options.onModalClose
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_base_image, {
                class: "gfu-push-notification__image gfu-embed gfu-embed--1x1",
                src: "/content/images/static/push-notification/push-notification-asset.svg"
              }),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.Resources.Layout.PushNotificationModalTitle), 1 /* TEXT */),
                _createTextVNode(" " + _toDisplayString($options.pushNotificationModalText), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_5, [
                ($options.isPushPermissionStatusDenied)
                  ? (_openBlock(), _createBlock(_component_base_button, {
                      key: 0,
                      tag: "a",
                      theme: "accent",
                      href: $options.url
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.Layout.WebPushHowToUnblockLink), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["href"]))
                  : (_openBlock(), _createBlock(_component_base_button, {
                      key: 1,
                      theme: "accent",
                      onClick: _withModifiers(_ctx.onEnablePush, ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.Layout.PushNotificationEnableButton), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])),
                _createElementVNode("button", {
                  class: "_ttl _fw-n _tc--accent",
                  onClick: _cache[0] || (_cache[0] = (...args) => ($options.onModalClose && $options.onModalClose(...args)))
                }, _toDisplayString(_ctx.Resources.Layout.PushNotificationDenyButton), 1 /* TEXT */)
              ])
            ])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["is-processing", "onOpen", "onActionClose"]))
    : _createCommentVNode("v-if", true)
}